export const APP_NAME = 'credit-bureau';

export const CREDIT_BUREAU_ROUTE_ROOT = '/creditBureau';
